import React, { useState, useEffect } from 'react';
import { Form, Spinner, Alert } from 'react-bootstrap';
import { ServiceFactory } from '../../Api/Services/ServiceFactory';
import { ServiceNames } from '../../Api/registry/Services';
import { useToast } from '../../components/ToastContext/ToastContext';
import { useTranslation } from 'react-i18next';
import './cropselector.css';

const CropSelector = ({ onSelect, selectedCrop }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [crops, setCrops] = useState([]);
    const { t } = useTranslation();
    const { showToast } = useToast();

    useEffect(() => {
        const fetchCrops = async () => {
            setLoading(true);
            setError(null);
            try {
                const modelService = await ServiceFactory.getService(ServiceNames.ServiceModel);
                const cropsData = await modelService.findCrops();
                // Assicuriamoci che cropsData sia un array
                const cropsArray = Array.isArray(cropsData) ? cropsData : cropsData?.content || [];
                setCrops(cropsArray);
            } catch (error) {
                showToast(error.message || t("error:wrong"), "error");
                setError(t("error:loadCropsFailed"));
            } finally {
                setLoading(false);
            }
        };

        fetchCrops();
    }, [t, showToast]);

    if (loading) {
        return (
            <div className="text-center p-4">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2">{t("cropselector:messages.loadingCrops")}</p>
            </div>
        );
    }

    if (error) {
        return (
            <Alert variant="danger">
                {error}
            </Alert>
        );
    }

    if (crops.length === 0) {
        return (
            <Alert variant="info">
                {t("cropselector:messages.noCrops")}
            </Alert>
        );
    }

    for (var i = 0; i < crops.length; i++) {
        if (crops[i].name == 'Generic crop')
            crops.splice(i, 1);
    }

    return (
        <div className="crop-selector">
            <Form.Group>
                <Form.Select
                    value={selectedCrop?.id || ''}
                    onChange={(e) => {
                        const selectedId = e.target.value;
                        const crop = crops.find(c => c.id === selectedId);
                        onSelect(crop || null);
                    }}
                    className="crop-select"
                >
                    <option value="">{t("cropselector:messages.chooseCrop")}</option>
                    {Array.isArray(crops) && crops.map((crop) => (
                        <option key={crop.id} value={crop.id}>
                            {crop.name}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>
        </div>
    );
};

export default CropSelector;